import { useMemo } from 'react'
import { useModelStore } from '@editorStores'
import useIsPositionPlanPreview from './useIsPositionPlanPreview'

const NOTHING_HIDDEN: Record<string, boolean> = {}

/**
 * The elements whose geometry the position plan PDF leaves out (`positionPlanSettings.pdf
 * .showGeometry`), while the position plan is previewed. Only their meshes are hidden: their
 * labels stay, as in the export.
 */
const usePositionPlanGeometryGuidToHidden = (): Record<string, boolean> => {
  const isPositionPlan = useIsPositionPlanPreview()
  const model = useModelStore(state => state.model)

  return useMemo(() => {
    if (!isPositionPlan) return NOTHING_HIDDEN

    const hidden: Record<string, boolean> = {}
    ;[
      ...model.beams,
      ...model.purlins,
      ...model.columns,
      ...model.vertical_slabs,
      ...model.vertical_roof_slabs,
    ].forEach(element => {
      if (!element.positionPlanSettings.pdf.showGeometry) hidden[element.guid] = true
    })
    ;[...model.rips, ...model.lintels].forEach(position => {
      if (!position.positionPlanSettings.pdf.showGeometry) hidden[position.position_guid] = true
    })
    return hidden
  }, [isPositionPlan, model])
}

export default usePositionPlanGeometryGuidToHidden
